<template>
  <div v-if="configData.FullBackground && isPage">
    <div :class="[`${isPage ? 'page-wrapper' : ''}`]">
      <slot />
    </div>
  </div>

  <div v-else-if="configData.FullBackground">
    <slot />
  </div>

  <div v-else-if="isPage" :class="[`${isPage ? 'page-wrapper' : ''}`]">
    <slot />
  </div>

  <slot v-else></slot>
</template>

<script setup lang="ts">
interface Props {
  configData: {
    FullBackground: boolean;
  };
  isPage: boolean;
}

defineProps<Props>();
</script>

<style scoped lang="scss"></style>
